<template>
    <div class="widget-item json-widget">
        <a v-if="!editDisabled && !widgetData.required && $parent.createMode" class="remove-widget" @click.prevent="$parent.removeWidget(this.widgetData.id);"><i class="fa fa-times"></i></a>
        <div class="widget-body">
            <div class="row">
                <div class="col-12">
                    <div class="title">{{this.widgetData.title}}</div>
                    <pre class="value">{{this.widgetData.data}}</pre>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import moment from 'moment';

    Vue.use(VueEvents)

    export default {
        name: 'widget-json',
        props: [
            'widgetData',
            'editDisabled',
        ],
        data() {
            return {
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                uiStates: {
                    showLoading: true,
                },
                loggedInPlanDetails: this.planDetails,
            }
        },
    };
</script>

<style scoped="" lang="scss">
    .json-widget{
        padding-top: 15px !important;
        padding-bottom: 15px !important;
        .value{
            border:1px solid red;
            height: 170px;
            margin-top: 15px;
            border-radius: 3px;
            overflow: auto;
            padding: 10px;
            border: 1px solid #e7eef5;
            background-color: #f9fbff;
            &::-webkit-scrollbar {
                width: 4px;
                height: 4px;
            }
            &::-webkit-scrollbar-track {
                background: #DEE0E1;
                position: absolute;
                top: 0px;
                bottom: 0px;
                right: 0px;
            }
            &::-webkit-scrollbar-thumb {
                background: #25628F;
                border-radius:2px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: #25628F;
            }
        }
        .title{
            font-size: 18px;
            color: #1F2529;
            text-align: center;
        }
    }
</style>
